module.exports = __webpack_public_path__ + "img/pic.d73e69b5.png";